import { logger } from '../utilities/logger';

type AuthenticationContext = {
    origin?: string;
    type?: string;
};

export const getAuthenticationContext = (): AuthenticationContext => {
    const authenticationContext = window.sessionStorage.getItem('authentication');
    if (authenticationContext) {
        try {
            return JSON.parse(authenticationContext);
        } catch (_) {
            logger.info(`SessionStorage Invalid JSON ${authenticationContext}`);
        }
    }
    return {} as AuthenticationContext;
};

export const storeAuthenticationContext = (state: AuthenticationContext): void => {
    const context = getAuthenticationContext();
    context.origin = state?.origin || context.origin;
    context.type = state?.type || context.type;
    try {
        window.sessionStorage.setItem('authentication', JSON.stringify(context));
    } catch (e) {
        logger.info(`SessionStorage: ${e.message}`);
    }
};

export const clearAuthenticationContext = (): void => {
    window.sessionStorage.removeItem('authentication');
};
